import {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useAuth} from "../hooks/useAuth.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFingerprint, faIdCard, faKey } from "@fortawesome/free-solid-svg-icons";
import {motion} from "framer-motion";
import axios from "../axios/axios";

import "../styles/Login.scss";

function Login({ socket }) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [error, setError] = useState("");
    const [isAlreadyRateLimited, setIsAlreadyRateLimited] = useState(false);

    let navigate = useNavigate();
    let location = useLocation();
    let { setUser, setPermissionLevel } = useAuth();

    //This stuff doesnt redirect somehow yet, fix
    let from = location.state?.from?.pathname || "/";
    if (from === "/login") {
        from = "/dlls";
    }

    const submit = async () => {
        console.log(`User: ${username}, pass: ${password}`);

        try {
            const response = await axios.post("/login", { username, password });
            
            if (response.status === 200 && response.data.success) {
                const { username, token, permissionLevel } = response.data;

                //Save token and set user for authProvider
                localStorage.setItem("token", token);
                setUser(username);
                setPermissionLevel(permissionLevel);

                //Update socket auth token and connect
                socket.io.opts.auth.token = token; 
                socket.connect();
                
                //All requests from now on attach the bearer token
                axios.defaults.headers.common["Authorization"] = `Bearer ${token}`; 
                console.log("navigating to ", from);
                //Go back to the site the user originally wanted to visit
                navigate(from, {replace: true});
            }
            else {

                //Show error such as wrong user/pw
                setError(response.data.message);
            }
        }
        catch (exception) {

            //Either the request failed or we got rate limited
            if (exception.response) {
                const {status} = exception.response;
                
                //Too many requests
                if (status === 429) {
                    if (!isAlreadyRateLimited) {
                        setError("Slow down hackerman :)");
                        setIsAlreadyRateLimited(true);
                    }
                    else
                    {
                        window.alert(":)");
                        window.location.href = "https://www.youtube.com/watch?v=NQemwKeGRg0";
                    }
                }
            }

        }
        

    }

    useEffect(() => {
        setError("");
    }, [username, password]);

    return (
        <motion.div
            initial={{opacity: 0, scale: 0.9}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.15}}
            exit={{opacity: 0, scale: 0.9}}
        >
            <div className="login-section">
                <motion.div
                    initial={{opacity: 0, scale: 0.9}}
                    animate={{opacity: 1, scale: 1}}
                    transition={{delay: 0.1}}
                    exit={{opacity: 0, scale: 0.9}}
                >
                    <h1>Anvil</h1>
                </motion.div>

                <motion.div
                    initial={{opacity: 0, scale: 1, y: 50}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    transition={{delay: 0.2}}
                    exit={{opacity: 0, scale: 0.9}}
                >
                    <div className="container">

                        <div className="fields">
                            <div className="label">
                                <FontAwesomeIcon className="icon" icon={faIdCard} />
                                User
                            </div>
                            <input type="text" placeholder="Username" value={username} onChange={event => setUsername(event.target.value)}/>

                            <div className="label">
                                <FontAwesomeIcon className="icon" icon={faKey} />
                                Password
                            </div>
                            <input type="password" placeholder="Password" value={password} onChange={event => setPassword(event.target.value)}/>
                        </div>
                       

                        
                        <motion.button 
                            initial={{opacity: 0,  y: 50, scale: 2}}
                            animate={{opacity: 1,  y: 0, scale: 1}}
                            transition={{delay: 0.3}}
                            onClick={submit}
                        >
                            <FontAwesomeIcon className="icon" icon={faFingerprint} />
                        </motion.button>
                        {
                            error ? 
                            (
                                <div className="errors">
                                    {error}
                                </div>
                            ) : ("")
                        }
                    </div>
                </motion.div>
                
            </div>
        </motion.div>
        
    );
}

export default Login;